import styled, { css } from 'styled-components'
import { irem } from 'utils'
import { AltBg } from '../flexibleContent/fragments/altBg'

export const ColumnCard = styled.div<{ $altBg?: boolean | null }>`
    --column-card-bg: ${props => props.theme.custom.colors.orange};
    
    ${AltBg} & {
        --column-card-bg: white;
    }
    
    & & { // Swap again for nested cards...
        --column-card-bg: white;
        
        ${AltBg} & {
            --column-card-bg: ${props => props.theme.custom.colors.orange};
        }
    }
    
    ${props => props.$altBg && css`
        background: var(--column-card-bg);
        padding: ${irem(35)} ${irem(20)};
        border-radius: ${irem(12)};

        ${props => props.theme.breakpoints.up('md')} {
            padding: ${irem(40)} ${irem(35)};
        }
    `}
    
    ul, ol {
        &:first-child {
            margin-top: 0;
        }
        
        &:last-child {
            margin-bottom: 0;
        }
    }

    img {
        object-fit: cover;
        border-radius: ${props => props.theme.typography.pxToRem(12)};
    }
`